import PropTypes from 'prop-types';
import * as React from 'react';
import { useSelectionSetContext, SelectionSetInputContext } from './selection-set.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    value: PropTypes.string.isRequired
};
const propKeysToRemove = [] // Value  should be passed
;
/**
 * @subcomponent SelectionSet
 */ const SelectionSetInput = renderWithRef('SelectionSetInput', propTypes, (props, ref)=>{
    const { value, children, id: customId, onChange: customOnChange } = props;
    const selectionSetContext = useSelectionSetContext();
    const id = useId(customId);
    const isMultiSelect = selectionSetContext.variant === 'multi-select';
    const classNames = [
        'swan-selection-set-input',
        isMultiSelect ? 'swan-checkbox' : 'swan-radio'
    ];
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ const checked = isMultiSelect ? selectionSetContext.selectedValues[value] : selectionSetContext.selectedValue === value;
    const onChange = isMultiSelect ? (event)=>{
        selectionSetContext.onSelectedValuesChange(_object_spread_props(_object_spread({}, selectionSetContext.selectedValues), {
            [value]: event.target.checked
        }), event);
    } : (event)=>{
        if (event.target.checked) {
            /* eslint-enable @typescript-eslint/no-non-null-assertion */ selectionSetContext.onSelectedValueChange(value, event);
        }
    };
    const forwardedProps = _object_spread_props(_object_spread({
        type: isMultiSelect ? 'checkbox' : 'radio'
    }, props), {
        id,
        name: selectionSetContext.name,
        value,
        checked,
        onChange: composeEventHandlersUtil(customOnChange, onChange)
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "input",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: forwardedProps
    }), /*#__PURE__*/ React.createElement(SelectionSetInputContext.Provider, {
        value: {
            selectionSetInputId: id
        }
    }, children));
});

export { SelectionSetInput };
